import {KTSVG} from '_metronic/helpers'
import ButtonExport from 'app/components/ButtonExport'
import {reportTypes} from 'app/constant'
import React from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {RootState} from 'setup'

interface Props {
  filter: any
}

const OrderListHeader: React.FC<Props> = ({filter}) => {
  const paging = useSelector<RootState>(({misc}) => misc.paging) as any

  return (
    <div className='d-flex justify-content-between'>
      <Link
        id='btnCreateOrder'
        to='/orders/draft/new'
        className='btn fw-bolder d-flex align-items-center'
      >
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3 svg-icon-dark' />
        Create Order
      </Link>

      <ButtonExport
        reportType={reportTypes.sales}
        className='ms-2'
        filter={filter}
        totalCount={paging.totalCount}
        orders={true}
      />
    </div>
  )
}

export default OrderListHeader
